﻿import $ from 'jquery';
import ko from 'knockout';
import { IBinder, IBehaviorBinding, ICellBinding } from "./ibinder"

export class ForEachBinder implements IBinder {
  public getElements(root: JQuery): JQuery {
    return root.find("tbody");
  }

  public getBinding(element: JQuery): IBehaviorBinding {

    return {
      bindingName: "foreachInit",
      bindTo: "Rows",
      behavior: null
    }
  }
}
